





































































import Vue from "vue";
import store from "@/store";
import { LoginWithCredentialsRequest } from "@/api";
import stateMixin from "@/mixins/state";

export default Vue.extend({
  data() {
    return {
      emailAddress: "",
      password: "",
      verificationPin: null,
      verificationPinRequired: false,
      rules: {
        emailAddress: [(v: string) => !!v || "E-mailadres is verplicht"],
        password: [(v: string) => !!v || "Wachtwoord is verplicht"],
        verificationPin: [(v: string) => !!v || "Code is verplicht"]
      },
      valid: true
    };
  },
  name: "Login",
  mixins: [stateMixin],
  methods: {
    handleSubmit() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const credentials: LoginWithCredentialsRequest = {
          emailAddress: this.emailAddress,
          password: this.password
        };
        const action = this.verificationPinRequired
          ? `auth/login`
          : `auth/login`;
        this.$store
          .dispatch("auth/login", {
            credentials: credentials,
            code: this.verificationPin
          })
          .then(() => {
            if (this.$store.getters["auth/isLoggedIn"]) {
              this.$router.push("/");
            } else {
              this.setState(this.states.ERROR);
              if (this.$store.getters["auth/tokenNeeded"]) {
                this.valid = true;
                this.setState(this.states.INITIAL);
                this.verificationPinRequired = true;
              }
            }
          });
      }
    }
  }
});
